import React, { useState } from "react";
import { TrendingUp, Target, Shield } from "react-feather";
import "../MarketPositionNew.css";


const ExecutiveOverview = () => {
  const [selectedCompanyBreakdown, setSelectedCompanyBreakdown] =
    useState(null);

  const scoreBreakdown = {
    schneider: {
      overall: 8.5,
      dimensions: [
        {
          name: "Share Rank",
          score: 9.5,
          explanation:
            "Global leader in energy management and industrial automation with ~€38.2B ($41B) FY2024 revenue and #1 DCPI share alongside top LV/MV distribution positions.",
        },
        {
          name: "Geographic Mix",
          score: 9,
          explanation:
            "Operates 160 plants and 75 DCs across North America (36%), APAC (27%), Europe (24%) and RoW (13%), giving true multi-region delivery strength.",
        },
        {
          name: "Segment Mix",
          score: 9,
          explanation:
            "Highly diversified across Energy Management (82%) and Industrial Automation (18%), spanning data centers (~24% of mix), buildings, industry and grid with strong software pull-through.",
        },
        {
          name: "Customer Satisfaction",
          score: 8.2,
          explanation:
            "Gartner #1 supply chain (2025), strong EcoStruxure/AVEVA service ecosystem, and solid ratings (Gartner Peer Insights 4.3/5) support above-average loyalty in mission-critical environments.",
        },
        {
          name: "Concentration Risk",
          score: 7,
          explanation:
            "Exposure concentrated in North America (36%) and AI/data centers (~24% of sales) but balanced by broad industry mix and software/services recurring revenue.",
        },
      ],
    },
    nvent: {
      overall: 6.9,
      dimensions: [
        {
          name: "Share Rank",
          score: 6.8,
          explanation:
            "Mid-tier specialist in electrical connection, protection, and thermal management (~$3.3B revenue; brands Hoffman, Schroff, Raychem) competing against larger diversified peers.",
        },
        {
          name: "Geographic Mix",
          score: 6.5,
          explanation:
            "Sells in 100+ countries with ~30+ manufacturing sites, but revenue skews to North America/Europe; limited scale in APAC versus Schneider and Boyd.",
        },
        {
          name: "Segment Mix",
          score: 7.5,
          explanation:
            "Balanced across enclosures, fastening/connection, and thermal management; growing liquid-cooling/CDU portfolio adds a fourth high-growth leg in data centers.",
        },
        {
          name: "Customer Satisfaction",
          score: 7.2,
          explanation:
            "Known for reliable availability, UL/IEC compliance, and responsive channel support via distributors; strong in industrial enclosures and heat-trace serviceability.",
        },
        {
          name: "Concentration Risk",
          score: 6.5,
          explanation:
            "Heavy exposure to North American construction/industrial cycles; diversification helped by data-center busway/CDUs but still building presence in APAC.",
        },
      ],
    },
    boyd: {
      overall: 6.5,
      dimensions: [
        {
          name: "Share Rank",
          score: 7,
          explanation:
            "Strong player in liquid cooling (5M cold plates shipped, 2MW CDUs) and engineered materials; pending $9.5B thermal sale to Eaton underscores category relevance.",
        },
        {
          name: "Geographic Mix",
          score: 7,
          explanation:
            "Roughly 40+ sites across Americas, Europe, and APAC (Vietnam mega-campus, Poland, Mexico, US), enabling multi-continent fulfillment though EMEA/LATAM thinner.",
        },
        {
          name: "Segment Mix",
          score: 6.5,
          explanation:
            "Concentrated in data-center cooling plus materials for auto/industrial/medical; narrower than diversified peers but spans multiple OEM-heavy verticals.",
        },
        {
          name: "Customer Satisfaction",
          score: 7,
          explanation:
            "ISO/IATF/AS9100 footprint, 3M Preferred Converter, and recent supplier awards (BAE, Gentex) indicate solid quality and delivery performance.",
        },
        {
          name: "Concentration Risk",
          score: 5,
          explanation:
            "High reliance on AI/data-center cooling and a few hyperscalers; divestiture/integration timing adds execution and customer concentration risk.",
        },
      ],
    },
  };

  const companies = [
    {
      company: "Schneider Electric",
      companyId: "schneider",
      score: "8.5/10",
      status: "Market leader",
      insight: "Integrated power+software stack dominating data centers and LV distribution",
      colorClass: "bg-danger",
      width: "85%",
    },
    {
      company: "nVent (Us)",
      companyId: "nvent",
      score: "6.9/10",
      status: "Competitive",
      insight: "Strong in enclosures/heat-trace; scaling liquid cooling and busway",
      colorClass: "bg-primary",
      width: "69%",
    },
    {
      company: "Boyd Corporation",
      companyId: "boyd",
      score: "6.5/10",
      status: "Strong competitor",
      insight: "AI liquid-cooling scale and global materials footprint",
      colorClass: "bg-info",
      width: "65%",
    },
  ];

  return (
    <div>
      <style>{`
        .executive-summary-card {
          border-bottom: 1px solid #e9ecef;
          background-color: #f7f9ff;
          padding: 12px;
          border: solid 1px #98a4aa33;
          border-radius: 8px;
          margin-bottom: 10px;
        }
        .exe_summary {
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
          color: #1e1c25;
        }
        .summary-icon-box {
          width: 3.5rem;
          height: 3.5rem;
          background: #fff;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .stat-card {
          padding: 12px 15px;
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          border: 1px solid #eee;
          position: relative;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 12px;
          text-align:center;
        }
        .score_inter{
          font-weight: 400;
          font-size: 12px;
          background-color: #f0f4fa;
          line-height: 1.4;
          color: rgba(0, 0, 0, 0.6);
          /* margin-top: 5px; */
          margin-bottom: 20px;
          padding: 12px 8px 12px 12px;
          border-radius: 8px;
        }
        .stat-card-text {
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom: 0.5rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .stat-card-value {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 0.25rem;
          line-height: 1;
          color: #000;

        }
        .stat-card-label {
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;

        }
        .bottom-line-card {
          padding: 12px 15px;
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          border: 1px solid #eee;
          position: relative;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 12px;
          text-align: center;
        }
        .bottom-line-card p{
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom:0px;
        }
        .sub_para{
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom:0px;
        }
        .threat-card {
          padding: 12px 16px;
          border-radius: 8px;
          border: 1px solid;
          height: 100%;
        }
        .threat-card-high {
          background-color: #fef2f2;
          border: 1px solid #b91c1c29;
        }
        .number_danger, .badge_danger{
          background-color:#b91c1c !important;
          border-radius:5px !important;
        }
        .list_li{
          font-weight: 400;
          font-size: 12px;
          line-height: 17.4px;
          margin-bottom: 10px;
          color: #1e1c25;
          align-items: start;
          display: flex;
        }
        .dot_list{
          margin-right:5px;
        }
        .text-warning-med{

        }
        .score{
          font-size:12px;
        }
        .threat-card-medium {
          background-color: #eff6ff;
          border: 1px solid #2563eb29;
        }
        .number_med, .number_badge_med{
          background-color:#1e74e6 !important;
          color:#fff !important;
        }
        .number_low, .number_badge_low{
          background-color:#15803d !important;
          color:#fff !important;
        }
        .threat-card-low {
          background-color: #f0fdf4;
          border: 1px solid #15803d29;
        }
        .score-bar-container {
          height: 13px;
          background: #e9ecef;
          border-radius: 8px;
          overflow: hidden;
          position: relative;
        }
        .score-bar {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 1rem;
          transition: all 0.5s ease;
          cursor: pointer;
          font-size:12px;
        }
        .score-bar:hover {
          opacity: 0.9;
          transform: scaleY(1.05);
        }
        .company-card {
          margin-bottom: 1rem;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          padding: 10px 16px;
        }
        .company-card-highlight {
          background: #e7f3ff;
          border: 2px solid #0d6efd;
          box-shadow: 0 4px 10px rgba(13,110,253,0.2);
        }
        .breakdown-card {
          background: linear-gradient(135deg, #e7f3ff 0%, #eef2ff 100%);
          border-radius: 0.75rem;
          padding: 1.5rem;
          border: 2px solid #0d6efd;
          box-shadow: 0 8px 20px rgba(13,110,253,0.2);
          margin-top: 1rem;
          margin-bottom: 1rem;
        }
        .dimension-card {
          background: #fff;
          border-radius: 0.5rem;
          padding: 1rem;
          transition: all 0.3s ease;
        }
        .dimension-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        .dimension-progress {
          height: 0.5rem;
          background: #e9ecef;
          border-radius: 1rem;
          overflow: hidden;
          position: relative;
        }
        .dimension-progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #0d6efd 0%, #0b5ed7 100%);
          transition: width 0.5s ease;
        }
        .priority-card {
          position: relative;
          padding: 12px 16px;
          border-radius: 8px;
          border: 1px solid;
          height: 100%;
        }
        .priority-number {
          position: absolute;
          top: -0.75rem;
          left: -0.75rem;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 14px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        }
        .priority-defend {
          background-color: #fef2f2;
          border: 1px solid #B91C1C29;
        }
        .attack_number{
          background-color:#1e74e6 !important;
        }
        .defend_number{
          background-color:#b91c1c !important;
        }
        .avoid_number{
          background-color:#15803d !important;
        }
        .priority-attack {
          background-color: #eff6ff;
          border: 1px solid #2563EB29;
        }
        .priority-avoid {
          background-color: #f0fdf4;
          border: 1px solid #15803D29;
        }
        .main_head_strat{
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
        }
        .main_subhead_strat{
          font-weight: 600;
          font-size: 13px;
          line-height: 17.5px;
        }
        .action-item {
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
          margin-bottom: 0.75rem;
          font-weight: 400;
          font-size: 12px;
          line-height: 17.4px;
          margin-bottom: 10px;
          color: #1e1c25;
        }
        .company_name_item{
          font-weight: 600;
          font-size: 13px;
          line-height: 17.5px;
          color: #1e1c25;
        }
      `}</style>

      {/* Executive Summary */}
      <div className="executive-summary-card">
        <div className="d-flex align-items-start gap-2 mb-2">
          {/* <div className="summary-icon-box">
            <TrendingUp className="text-primary" size={28} />
          </div> */}
          <div>
            <h2 className="exe_summary ml-1">Executive Summary</h2>
          </div>
        </div>

        <div className="row g-3 mb-3">
          <div className="col-md-4">
            <div className="stat-card">
              <div className="stat-card-text">nVent Strength</div>
              <div className="stat-card-value">6.9/10</div>
              <div className="stat-card-label">Competitive</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stat-card">
              <div className="stat-card-text">Closest Competitor</div>
              <div className="stat-card-value">Boyd Corporation 6.5/10</div>
              <div className="stat-card-label">Within striking distance</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stat-card">
              <div className="stat-card-text">Market Leader</div>
              <div className="stat-card-value">Schneider Electric 8.5/10</div>
              <div className="stat-card-label">Dominant player</div>
            </div>
          </div>
        </div>

        <div className="bottom-line-card">
          <p className="">
            <strong>Bottom Line:</strong> nVent scores 6.9/10—competitive in enclosures, heat-trace, and emerging liquid cooling, but trails Schneider Electric’s integrated power/software scale (8.5/10). Schneider’s global footprint and spec control in AI data centers are the primary threat; Boyd (6.5/10) is the closest follower with hyperscaler liquid-cooling traction.
          </p>
        </div>
      </div>

      {/* Threat Assessment */}
      <div className="card border-0  mb-2">
        <div className="card-body">
          <h3 className="exe_summary">Threat Assessment</h3>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="threat-card threat-card-high card_high_threat">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex gap-2">
                    <div
                      className="bg-danger text-white rounded p-2 number_danger fw-bold "
                 
                    >
                      8.5
                    </div>
                    <div>
                      <div className="fw-bold font13">Schneider Electric</div>
                      <div className="text-muted score">Score: 8.5/10</div>
                    </div>
                  </div>
                  <span className="badge bg-danger badge_danger font11">HIGH THREAT</span>
                </div>
                <div className="small">
                  <div className="mb-2 list_li">
                    <span className="text-danger-high fw-bold dot_list">• </span>
                    <span><strong>Spec control in AI data centers:</strong> Bundles UPS, racks, busway, BMS, and services, crowding out enclosure/thermal slots.</span>
                  </div>
                  <div className="mb-2 list_li">
                    <span className="text-danger-high fw-bold dot_list">• </span>
                    <span><strong>Global delivery muscle:</strong> 160 plants/75 DCs plus regionalized NA capacity narrows lead-time advantages.</span>
                  </div>
                  <div className="list_li">
                    <span className="text-danger-high fw-bold dot_list">• </span>
                    <span><strong>Software-led lock-in:</strong> AVEVA/ETAP/ EcoStruxure drive recurring pull-through and switching costs.</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="threat-card threat-card-medium">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex gap-2">
                    <div
                      className="bg-info text-white rounded p-2 fw-bold number_med">
                      6.5
                    </div>
                    <div>
                      <div className="fw-bold font13">Boyd Corporation</div>
                      <div className="small text-muted score">Score: 6.5/10</div>
                    </div>
                  </div>
                  <span className="badge bg-warning text-dark number_badge_med font11">
                    MEDIUM THREAT
                  </span>
                </div>
                <div className="small">
                  <div className="mb-2 list_li">
                    <span className="text-warning-med fw-bold dot_list">• </span>
                    <span> <strong>AI liquid-cooling scale:</strong> 5M cold plates shipped and 2MW CDUs compete head-on with nVent’s new CDU portfolio.</span>
                  </div>
                  <div className="mb-2 list_li">
                    <span className="text-warning-med fw-bold dot_list">• </span>
                    <span><strong>Global cost/volume footprint:</strong> Vietnam/Poland/Mexico capacity compresses cost and delivery advantages.</span>
                  </div>
                  <div className="list_li">
                    <span className="text-warning-med fw-bold dot_list">• </span>
                    <span><strong>Integration tailwind:</strong> Pending Eaton ownership could boost channel reach and capital to scale faster.</span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-4">
              <div className="threat-card threat-card-low">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex gap-2">
                    <div
                      className="bg-secondary text-white rounded p-2 fw-bold number_low"
                                   >
                      4.2
                    </div>
                    <div>
                      <div className="fw-bold font13">Regional Panel Builders</div>
                      <div className="small text-muted score">Score: 4.2/10</div>
                    </div>
                  </div>
                  <span className="badge bg-success number_badge_low font11">LOW THREAT</span>
                </div>
                <div className="small ">
                  <div className="mb-2 list_li">
                    <span className="text-success-low fw-bold dot_list">• </span>
                    <span> <strong>Limited scale:</strong> Local fabrication with narrow product sets can’t match certification or global service.</span>
                  </div>
                  <div className="mb-2 list_li">
                    <span className="text-success-low fw-bold dot_list">• </span>
                    <span> <strong>Geography bound:</strong> Single-region reach reduces relevance in multinational specs.</span>
                  </div>
                  <div className="list_li">
                    <span className="text-success-low fw-bold dot_list">• </span>
                    <span><strong>Partner opportunity:</strong> Potential channel partners for fast-turn custom builds under nVent standards.</span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* How We Compare */}
      <div className="card border-0">
        <div className="card-body">
          <h3 className="exe_summary">How We Compare</h3>
          <p className="sub_para mb-2">
            Scores reflect overall competitive strength based on scale,
            capabilities, market position, and growth trajectory.
          </p>

          <div className="sub_para mb-3 d-flex justify-content-between align-items-center">
            <div className="text-muted">
              <strong>Note:</strong> Scores based on analysis of 3 key
              competitors.
            </div>
            <div className="d-flex gap-3">
              <div className="d-flex align-items-center gap-1">
                <div
                  className="bg-danger"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    borderRadius: "2px",
                  }}
                ></div>
                <span className="text-muted">Market Leader (8.5+)</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <div
                  className="bg-info"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    borderRadius: "2px",
                  }}
                ></div>
                <span className="text-muted">Strong Player (7.5-8.5)</span>
              </div>
            </div>
          </div>

          {companies.map((item, idx) => (
            <div key={idx}>
              <div
                className={`company-card ${
                  idx === 1 ? "company-card-highlight" : ""
                }`}
              >
                <div className="row align-items-center">
                  <div className="col-md-3">
                    <div className="fw-bold company_name_item">{item.company}</div>
                    <div className="small text-muted sub_para">{item.status}</div>
                  </div>
                  <div className="col-md-9">
                    <div className="score-bar-container">
                      <div
                        className={`score-bar ${item.colorClass}`}
                        style={{ width: item.width }}
                        onClick={() =>
                          setSelectedCompanyBreakdown(
                            selectedCompanyBreakdown === item.companyId
                              ? null
                              : item.companyId
                          )
                        }
                        title="Click to see score breakdown"
                      >
                        <span className="text-white fw-bold fs-9">
                          {item.score}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="small text-muted fst-italic sub_para"
                  style={{ marginLeft: "26%", marginTop:"-10px" }}
                >
                  {item.insight}
                </div>
              </div>

              {selectedCompanyBreakdown === item.companyId && (
                <div className="breakdown-card">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="h6 fw-bold mb-0">
                      {item.company} Score Details
                    </h4>
                    <button
                      onClick={() => setSelectedCompanyBreakdown(null)}
                      className="btn btn-dark btn-sm"
                    >
                      ✕ Close
                    </button>
                  </div>

                  <div className="bg-white rounded p-3 mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="fw-bold">Overall Score</span>
                      <span className="display-6 fw-bold text-primary">
                        {scoreBreakdown[item.companyId].overall}/10
                      </span>
                    </div>
                    <div className="small text-muted">
                      Calculated from 5 sub-dimensions below
                    </div>
                  </div>

                  <div className="row g-3">
                    {scoreBreakdown[item.companyId].dimensions.map(
                      (dim, dimIdx) => (
                        <div key={dimIdx} className="col-12">
                          <div className="dimension-card">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                  <span className="fw-semibold">
                                    {dim.name}
                                  </span>
                                  <span className="badge bg-primary">
                                    {dim.score}/10
                                  </span>
                                </div>
                                <div className="dimension-progress">
                                  <div
                                    className="dimension-progress-bar"
                                    style={{ width: `${dim.score * 10}%` }}
                                  ></div>
                                </div>
                              </div>
                            </div>
                            <p className="small text-muted mb-0 mt-2">
                              {dim.explanation}
                            </p>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}

          <div className="score_inter">
            <strong>Score Interpretation:</strong> 8.5-10 = Dominant market
            leader | 7.0-8.4 = Strong competitive player | 5.5-6.9 = Solid/Competitive position
          </div>
        </div>
      </div>

      {/* Strategic Priorities */}
      <div className="card border-0 mb-4">
        <div className="card-body">
          <h3 className="exe_summary mb-3">Strategic Priorities</h3>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="priority-card priority-attack">
                <div className="priority-number priority-number-attack bg-primary text-white attack_number">1</div>
                <h4
                  className="main_head_strat"
                  style={{ minHeight: "auto" }}
                >
                  ATTACK
                </h4>
                <div className="main_subhead_strat mb-3">
                  Pursue White Space
                </div>
                <div className="small">
                  <div className="action-item">
                    <Target className="text-primary1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Lock EU/APAC AI builds:</strong> Target hyperscaler co-los needing fast-ship racks/busway/CDUs where Schneider is thinner and Boyd lacks service density.
                    </div>
                  </div>
                  <div className="action-item">
                    <Target className="text-primary1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Win retrofit industrial enclosures:</strong> Bundle Hoffman/Schroff with heat-trace and service SLAs for OEM retrofits in regulated plants.
                    </div>
                  </div>
                  <div className="action-item">
                    <Target className="text-primary1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Publish open reference designs:</strong> Release interoperable CDU/manifold BOMs with NVIDIA/OCP partners to pre-empt single-vendor specs.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="priority-card priority-defend">
                <div className="priority-number bg-danger text-white defend_number">2</div>
                <h4
                  className="main_head_strat"
                  style={{ minHeight: "auto" }}
                >
                  DEFEND
                </h4>
                <div className="main_subhead_strat mb-3">
                  Protect Your Strengths
                </div>
                <div className="small">
                  <div className="action-item">
                    <Shield className="text-danger1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Guard enclosure leadership:</strong> Secure distributor loyalty with lead-time guarantees and bundled thermal/EMI kits in NA/EU core accounts.
                    </div>
                  </div>
                  <div className="action-item">
                    <Shield className="text-danger1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Hold heat-trace share:</strong> Double down on petrochem/utility programs with lifecycle service and digital monitoring to block bundled offers.
                    </div>
                  </div>
                  <div className="action-item">
                    <Shield className="text-danger1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Counter Schneider specs:</strong> Offer dual-source alternates (busway, racks, CDUs) with TCO guarantees and channel co-bids to stay in designs.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="priority-card priority-avoid">
                <div className="priority-number bg-warning text-white avoid_number">3</div>
                <h4
                  className="main_head_strat"
                  style={{ minHeight: "auto" }}
                >
                  AVOID
                </h4>
                <div className="main_subhead_strat mb-3">
                  Minimize Risk Exposure
                </div>
                <div className="small">
                  <div className="action-item">
                    <div
                      className="border border-warning1 rounded flex-shrink-0"
                      style={{ width: "1rem", height: "1rem" }}
                    ></div>
                    <div>
                      <strong>Price wars vs Schneider:</strong> Don’t chase low-margin LV gear bundles; compete on speed, openness, and service.
                    </div>
                  </div>
                  <div className="action-item">
                    <div
                      className="border border-warning1 rounded flex-shrink-0"
                      style={{ width: "1rem", height: "1rem" }}
                    ></div>
                    <div>
                      <strong>Immersion-only bets:</strong> Avoid over-investing in immersion SKUs where specialists lead; stay modular and interoperable with air/liquid paths.
                    </div>
                  </div>
                  <div className="action-item">
                    <div
                      className="border border-warning1 rounded flex-shrink-0"
                      style={{ width: "1rem", height: "1rem" }}
                    ></div>
                    <div>
                      <strong>Over-concentration in NA:</strong> Balance capacity with EU/APAC fast-ship nodes to reduce exposure to a single region’s cycle.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveOverview;